export class PointPairOrder {
    constructor() {
        // array of metrolines for node u of edge u->v
        this.Metrolines = new Array();
    }
    Add(metroline) {
        this.Metrolines.push(metroline);
    }
}
//# sourceMappingURL=PointPairOrder.js.map